

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"1800","height":"40","viewBox":"0 0 1800 40","preserveAspectRatio":"none"}, rest), ["\n  ", h('path', {"fill":"#FFF","fill-rule":"evenodd","d":"M0 0h1800v22.187C1667.936 34.062 1511.136 40 1329.6 40 1057.296 40 906 1.643 494.4 1.643 220 1.643 55.2 8.491 0 22.187V0z"}, []), "\n"]);
};

        